import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./template/pages/home/Home.tsx";
import Contact from "./template/pages/contact/Contact.tsx";
import About from "./template/pages/about/About.tsx";
import Portfolio from "./template/pages/portfolio/Portfolio.tsx";
import Header from "./template/structure/navbar/Header.tsx";
import Team from "./template/pages/team/Team.tsx";
import Footer from "./template/structure/footer/Footer.tsx";
import NotFound from "./template/pages/notFound/NotFound.tsx";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<Contact />} />
        {/* Gestion du 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
